import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline'

import { anim, prog, stagger } from '../../../motion'
import { Count } from '../../../primitives'
import { Line } from '../../../v2/kit'
import { useCopy } from '../../i18n'

// Vier Zeilen „ohne Aivy“ kippen nacheinander auf „mit Aivy“, danach die Belege
export default function DemoLever() {
  const c = useCopy('hebel')

  return (
    <div className='cin-pad cin-pad--top'>
      <div className='dm-lever-head'>
        <Line at={[0, 0.06]} className='cin-eyebrow cin-eyebrow--light'>
          {c.eyebrow}
        </Line>
        <div className='dm-swap'>
          <Line at={[0, 0.08]} out={[0.26, 0.32]} className='cin-title'>
            {c.before}
          </Line>
          <Line at={[0.3, 0.36]} className='cin-title dm-accent-green'>
            {c.after}
          </Line>
        </div>
      </div>

      <div
        className='dm-flips'
        style={anim({ at: [0.04, 0.12], out: [0.6, 0.66], y: 40, oy: -40 })}
      >
        <div className='dm-flips__legend'>
          <span style={{ ...prog([0.3, 0.34]), opacity: 'calc(1 - var(--p))' }}>
            {c.without}
          </span>
          <span
            className='dm-accent-green'
            style={{ ...prog([0.3, 0.34]), opacity: 'var(--p)' }}
          >
            {c.with}
          </span>
        </div>
        {c.rows.map(([before, after], i) => (
          <div key={before} className='dm-flip'>
            <div
              className='dm-flip__inner'
              style={prog(stagger(0.14, 0.08, 0.1, i))}
            >
              <div className='dm-flip__face dm-flip__face--front'>
                <XMarkIcon className='dm-flip__icon' />
                {before}
              </div>
              <div className='dm-flip__face dm-flip__face--back'>
                <CheckIcon className='dm-flip__icon' />
                {after}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className='dm-proof'>
        {c.proof.map((p, i) => (
          <div
            key={p.source}
            className='dm-proof__item'
            style={anim({ at: stagger(0.64, 0.05, 0.1, i), y: 60 })}
          >
            <Count
              to={p.to}
              at={stagger(0.66, 0.05, 0.16, i)}
              suffix=' %'
              className='dm-proof__num'
            />
            <div className='dm-proof__label'>{p.label}</div>
            <div className='dm-proof__source'>{p.source}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
